// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__19ahI","empty":"ModalGraph_empty__1ZFXr"};